<template>
  <!--子页面面板-->
  <div class="section-main__warp meeting-manage">
    <appCrudTab title="筛选面板">
      <template slot="form">
        <el-form :inline="true">
          <el-form-item label="计划名称">
            <el-input class="roomname-input" placeholder="请输入计划名称" v-model="planName"></el-input>
          </el-form-item>
          <el-form-item label="计划日期">
            <el-date-picker class="meeting-time-range" v-model="dates" type="daterange" start-placeholder="开始日期"
              end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="巡检人员">
            <el-input class="roomname-input" placeholder="请输入巡检人员" v-model="peopleName"></el-input>
          </el-form-item>
          <el-form-item label="频率">
            <el-select v-model="rate" placeholder="全部">
              <el-option v-for="item in rateList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划状态">
            <el-select v-model="status" placeholder="全部">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否逾期">
            <el-select v-model="overdue" placeholder="全部">
              <el-option v-for="item in overdueList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
    </appCrudTab>
    <!--数据面板-->
    <div style="
        flex: 1;
        height: 0;
        display: flex;
        flex-direction: column;
        background: #fff;
        margin-top: 15px;
        padding: 0 15px;
      ">
      <div class="ioc-crud__table" style="flex: 1; display: flex; flex-direction: column; overflow-y: auto">
        <div class="mt-1 mb-1" style="margin: 10px 0">
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        </div>
        <el-table style="flex: 1" ref="multipleTable" stripe :data="tableData">
          <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
          <el-table-column prop="planName" label="计划名称" align="center"></el-table-column>
          <el-table-column label="频率" align="center">
            <template slot-scope="scope">
              <span>{{
                dealplanDateRate(scope.row.planDateRate, rateList)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="计划日期" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.startDate
                ? scope.row.startDate.substring(0, 10)
                : ""
              }}
                至{{
                  scope.row.endDate ? scope.row.endDate.substring(0, 10) : ""
                }}</span>
            </template>
          </el-table-column>
          <el-table-column label="执行时间" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.startTime }} - {{ scope.row.endTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="执行人员" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="计划状态" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" active-color="#407AEE" inactive-color="#465275" :active-value="2"
                :inactive-value="1" @change="changeType(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column label="是否逾期" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.overDate ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="查看" placement="top-start">
                <i class="item-operation-icon el-icon-view icon-blue" @click="handleView(scope.row)"></i>
              </el-tooltip>
              <el-tooltip effect="dark" content="修改" placement="top-start">
                <i class="item-operation-icon el-icon-edit icon-blue" @click="handleEdit(scope.row)"></i>
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" placement="top-start">
                <i class="item-operation-icon el-icon-delete icon-blue" @click="handleSingleDelete(scope.row)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="el-table__empty-block">
              <span class="el-table__empty-text">
                <div class="ioc-crud__empty">
                  <div class="ioc-empty">
                    <div class="ioc-empty__image" style="height: 50px">
                      <img src="../img/empty.svg" alt="" />
                    </div>
                    <p class="ioc-empty__desc">暂无数据</p>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <div class="meeting-footer">
      <el-pagination background @size-change="pageSizeChange" @current-change="pageNoChange" :current-page.sync="pageNo"
        :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <add-plan-component :title="title" v-if="addVisible" :form="detailForm" @handleCancel="handleCancel"
      @handleConfirm="handleConfirm" />
    <view-plan-component v-if="viewVisible" @handleCancel="handleCancel" :title="title" :form="detailForm" />
  </div>
</template>

<script>
import AddPlanComponent from "@/modules/equipInspection/components/addPlanComponent";
import ViewPlanComponent from "@/modules/equipInspection/components/view-plan-component";
import appCrudTab from "../components/app-crud-tab/index.vue";
import api from "../api/index";

export default {
  name: "plan",
  components: { ViewPlanComponent, AddPlanComponent, appCrudTab },
  data() {
    return {
      detailForm: {},
      planName: "",
      dates: [],
      peopleName: "",
      rate: "",
      status: "",
      overdue: "",
      overdueList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
      statusList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "启用",
          value: 2,
        },
        {
          label: "停用",
          value: 1,
        },
      ],
      rateList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "每天",
          value: "0",
        },
        {
          label: "自定义",
          value: "1",
        },
      ],
      tableColumns: [
        {
          label: "序号",
          prop: "index",
          width: 60,
        },
        {
          label: "计划名称",
          prop: "planName",
        },
        {
          label: "频率",
          prop: "planDateRate",
        },
        {
          label: "计划日期",
          prop: "planDate",
        },
        {
          label: "执行时间",
          prop: "doTime",
        },
        {
          label: "执行人员",
          prop: "username",
        },
        {
          label: "计划状态",
          prop: "status",
        },
        {
          label: "是否逾期",
          prop: "overDate",
        },
        {
          label: this.$t("alarm.operatingLabel"),
          prop: "operating",
        },
      ],
      tableData: [],
      tableLoading: false,
      pageNo: 1,
      pageSize: 20,
      total: 0,
      addVisible: false,
      viewVisible: false,
      title: "",
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    /**
     * 删除单个计划
     */
    handleSingleDelete(row) {
      this.$confirm("确认删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDeletePlan(row);
        })
        .catch(() => { });
    },
    /**
     * 删除单个的请求
     * @param userId 用户ID string
     */
    handleDeletePlan(row) {
      let url = api.plan.delPlan + row.planId
      this.$fetchDelete(url).then((res) => {
        if (res.success) {
          this.$message.success("删除成功");
          this.handleSearch();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 频率转换
    dealplanDateRate(value, list) {
      let result = "";
      if (value && list && list.length) {
        list.forEach((item) => {
          if (item.value == value) {
            result = item.label;
          }
        });
      }
      return result;
    },
    handleCancel() {
      this.addVisible = false;
      this.viewVisible = false;
    },
    handleConfirm() {
      this.handleSearch();
      this.addVisible = false;
    },
    handleView(row) {
      this.detailForm = {};
      this.queryPlanDetail(row.planId);
      this.title = "计划详情";
      this.viewVisible = true;
    },
    handleAdd(row) {
      this.title = "新增计划";
      this.detailForm = {};
      this.addVisible = true;
    },
    handleEdit(row) {
      this.detailForm = {};
      this.queryPlanDetail(row.planId);
      this.title = "修改计划";
      this.addVisible = true;
    },
    // 获取计划详情
    queryPlanDetail(id) {
      let url = api.plan.getPlanDetail + id + "/detail";
      this.$fetchGet(url).then((res) => {
        if (res.success) {
          this.detailForm = res.data;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    /**
     * 切换规则状态
     * @param row
     */
    changeType(row) {
      if (row.status === 1) {
        let url = api.plan.stopPlan + `?id=${row.planId}`
        this.$fetch(url).then((res) => {
          if (res.success) {
            this.$message.success("停用成功");
            this.handleSearch();
          } else {
            this.$message.error(res.msgContent);
          }
        });
      } else {
        let url = api.plan.startPlan + `?id=${row.planId}`
        this.$fetch(url).then((res) => {
          if (res.success) {
            this.$message.success("启用成功");
            this.handleSearch();
          } else {
            this.$message.error(res.msgContent);
          }
        });
      }
    },
    /**
     * 计划查询
     */
    queryData() {
      this.tableLoading = true;
      let url =
        api.plan.getPlanList +
        `?pageSize=${this.pageSize}&pageNumber=${this.pageNo}&planType=1`;
      if (this.planName) {
        url += `&planName=${this.planName}`;
      }
      if (this.dates && this.dates.length) {
        url += `&startDate=${this.dates[0]}&endDate=${this.dates[1]}`;
      }
      if (this.rate) {
        url += `&planDateRate=${this.rate}`;
      }
      if (this.status) {
        url += `&status=${this.status}`;
      }
      if (this.status === 0) {
        url += `&status=0`;
      }
      if (this.peopleName) {
        url += `&username=${this.peopleName}`;
      }
      if (this.overdue) {
        url += `&overDate=${this.overdue}`;
      }
      this.$fetchGet(url).then((res) => {
        this.tableLoading = false;
        if (res.success) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    /**
     * 记录信息查询
     */
    handleSearch() {
      this.pageNo = 1;
      this.queryData();
    },
    /**
     * 重置
     */
    handleReset() {
      this.planName = "";
      this.peopleName = "";
      this.rate = "";
      this.status = "";
      this.overdue = "";
      this.dates = [];
      this.handleSearch();
    },
    /**
     * 每页记录数改变触发
     * @param pageSize 记录值
     */
    pageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.queryData();
    },
    /**
     * 当前页改变触发
     * @param pageNo 当前页码
     */
    pageNoChange(pageNo) {
      this.pageNo = pageNo;
      this.queryData();
    },
  },
};
</script>

<style lang='scss' scoped>
// @import '../../../assets/style/mixin';
.meeting-manage {
  display: flex;
  flex-direction: column;

  .item-operation-icon {
    font-size: 14px;
    cursor: pointer;
    margin: 0 8px;
  }

  .meeting-footer {
    background: #fff;
    display: flex;
    justify-content: center;
    padding: 15px 0;
  }
}

.alarm_options {
  display: flex;
  flex-direction: row;

  .options_icon {
    font-size: 20px;
    cursor: pointer;
    margin-right: 10px;

    // &:hover {
    //   @include set_primary_theme(color);
    // }
  }
}
</style>
